import { useEffect, useState } from "react";
import { api, errMessage } from "../lib/api";

export function useProposals({ sort = "liked", area = "", q = "", topic = "" }) {
  const [state, setState] = useState({ items: [], loading: true, error: "" });
  useEffect(() => {
    let live = true;
    setState((s) => ({ ...s, loading: true }));
    api.get("/proposals", { params: { sort, area: area || undefined, q: q || undefined, topic: topic || undefined } })
      .then(({ data }) => live && setState({ items: data.proposals, loading: false, error: "" }))
      .catch((e) => live && setState({ items: [], loading: false, error: errMessage(e) }));
    return () => {
      live = false;
    };
  }, [sort, area, q, topic]);
  return state;
}
